<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">{{currentPage === 'admin' ? 'Admin' : 'Reseller'}}</li>
      </ol>
      <h1 class="page-title">{{ $t("action.manageClientTeam") }}</h1>
      <div class="page-header-actions">
        <div class="row no-space w-120">
          <div class="col-xs-12 col-md-12">
            <div class="counter">
              <div class="counter-label p-t-5">{{ $t("text.totalTeams") }}</div>
              <span class="counter-number font-weight-medium">{{total_team}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body panel-form">
          <loading-indicator v-if="isLoading"></loading-indicator>
          <div v-else-if="isError">
          </div>
          <div v-else>
            <div class="p-b-15">
              <div class="row">
                <div class="col-xs-6 col-md-6">
                  <router-link v-bind:to="`/${$route.params.namespace}/${currentPage}/teams/create`" class="btn btn-primary">
                    <i class="icon md-plus" aria-hidden="true"></i><span class="text hidden-sm-down"> {{ $t("clientUsageHistory.action.create") }} </span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="p-b-15">
              <form v-on:submit.prevent="filterItems" autocomplete="off">
                <div class="row">
                  <div class="col-xs-4 col-md-2" v-if="showFilterItems">
                    <div class="form-group">
                      <label class="form-control-label">Pay Plan</label>
                      <select class="form-control" v-model="currentPayPlanType">
                        <option value="">Show all</option>
                        <option value="prepaid">Pre paid</option>
                        <option value="postpaid">Post paid</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-4 col-md-2" v-if="showFilterItems">
                    <div class="form-group">
                      <label class="form-control-label">Pricing Plan</label>
                      <select class="form-control" v-model="currentPricingPlanType">
                        <option value="">Show all</option>
                        <option v-for="(item, index) in pricingplanList" v-bind:value="item.alias">{{item.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-4 col-md-2" v-if="showFilterItems">
                    <div class="form-group">
                      <label class="form-control-label">Suspend</label>
                      <select class="form-control" v-model="currentSuspendType">
                        <option value="">Show all</option>
                        <option value="1">Suspend</option>
                        <option value="0">Active</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-3">
                    <div class="form-group">
                      <label class="form-control-label">{{ $t("text.textGuideFilter") }}</label>
                      <input type="text" class="form-control input-lg" id="team" placeholder="" v-model="currentName">
                    </div>
                  </div>
                  <div class="col-xs-4 col-md-2">
                    <button type="submit" class="btn btn-success m-t-35" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }"> <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div>{{ $t("action.search") }}</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="table-striped table-hover table-responsive" v-if="total_team">
              <table class="table">
                <thead>
                  <tr>
                    <th class="cell-50">ID</th>
                    <th class="cell-300">{{ $t("manageClientTeam.labels.name") }}</th>
                    <th class="cell-300">{{ $t("manageClientTeam.labels.url") }}</th>
                    <th class="cell-100">{{ $t("manageClientTeam.labels.type") }}</th>
                    <th class="cell-100 text-xs-center">{{ $t("manageClientTeam.labels.reseller") }}</th>
                    <th class="cell-100">{{ $t("manageClientTeam.labels.payPlan") }}</th>
                    <th class="cell-50"></th>
                    <th class="cell-50"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(team, index) in teams" v-bind:id="team.id">
                    <td class="cell-50">{{team.id}}</td>
                    <td class="cell-300">{{team.name}}</td>
                    <td class="cell-300">{{team.namespace}}</td>
                    <td class="cell-100">
                      <span v-if="team.is_reseller" class="tag tag-danger">Reseller</span>
                      <span v-else-if="team.has_reseller" class="tag tag-info">Sub Team</span>
                      <span v-else class="tag tag-default">Normal</span>
                    </td>
                    <td class="cell-100 text-xs-center">
                      <router-link
                        v-bind:to="`/${$route.params.namespace}/${currentPage}/teams/${team.reseller.namespace}/billings`" class="btn btn-link" alt="Reseller" v-if="team.has_reseller">{{team.reseller.name}}
                      </router-link>
                      <span v-else class="text-center">-</span>
                    </td>
                    <td class="cell-100">
                      <span v-if="team.pay_plan === 'postpaid'" class="red-600">{{ $t("payPlan.labels.postPaid") }}</span>
                      <span v-else>{{ $t("payPlan.labels.prePaid") }}</span>
                    </td>
                    <td class="cell-50 text-nowrap">
                      <router-link
                        v-bind:to="`/${$route.params.namespace}/${currentPage}/teams/${team.namespace}/billings`"
                        class="btn btn-sm btn-default" alt="Billing">{{ $t("menu.billing") }}
                      </router-link>
                    </td>
                    <td class="cell-50 text-nowrap">
                      <router-link
                        v-bind:to="`/${$route.params.namespace}/${currentPage}/teams/${team.namespace}/edit`"
                        class="btn btn-sm btn-default"
                        alt="Edit">{{ $t("action.manage") }}
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="alert alert-primary alert-dismissible" v-else>
              There is no team.
            </div>
          </div>
          <paginate
            v-show="(pagination.total_page > 1)"
            v-bind:pageCount="pagination.total_page"
            v-bind:prevText="'«'"
            v-bind:nextText="'»'"
            v-bind:clickHandler="changePage"
            v-bind:containerClass="'pagination pull-right'"
            v-bind:pageClass="'page-item'"
            v-bind:pageLinkClass="'page-link'"
            v-bind:prevClass="'page-item'"
            v-bind:prevLinkClass="'page-link'"
            v-bind:nextClass="'page-item'"
            v-bind:nextLinkClass="'page-link'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  data: function() {
    return {
      isSubmiting: false,
      isLoading: false,
      isError: false,
      total_team: 0,
      showFilterItems: false,
      teams: [],
      pricingplanList: [],
      currentPayPlanType: '',
      currentPricingPlanType: '',
      currentSuspendType: '',
      currentName: '',
      pagination: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 0,
        from: 1,
        to: 1,
        next_page_url: null,
        prev_page_url: null,
        total_page: 0,
      },
    };
  },
  created: function() {
    this.isLoading = true;
  },
  mounted: function() {
    this.fetchTeams();
    this.fetchPricingPlanList();

    if (this.currentUser.is_superadmin) {
      this.showFilterItems = true;
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    showUserRole: function() {
      if (!this.$route.params.subnamespace &&
        (this.currentUser.team.is_superadmin || this.currentUser.team.is_reseller)) {
        return false;
      } else {
        return true;
      }
    },
    currentPage: function () {
      if (this.currentUser.team.is_superadmin) {
        return 'admin';
      } else if (this.currentUser.team.is_reseller) {
        return 'reseller';
      }
    },
  },
  methods: {
    fetchPricingPlanList: function() {
      axios.get(`/api/pricingplans`)
      .then((response) => {
        this.pricingplanList = response.data.plans;
        this.currentPricingPlanType.alias = this.team.pricing_plan;

        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
    },
    fetchTeams: function(page) {
      let url = `/api/teams`;

      let hasFirstFiler = false;

      if (this.currentPayPlanType) {
        if (hasFirstFiler) {
          url = `${url}&pay_plan=${this.currentPayPlanType}`;
        } else {
          hasFirstFiler = true;
          url = `${url}?pay_plan=${this.currentPayPlanType}`;
        }
      }

      if (this.currentPricingPlanType) {
        if (hasFirstFiler) {
          url = `${url}&pricing_plan=${this.currentPricingPlanType}`;
        } else {
          hasFirstFiler = true;
          url = `${url}?pricing_plan=${this.currentPricingPlanType}`;
        }
      }

      if (this.currentSuspendType) {
        if (hasFirstFiler) {
          url = `${url}&is_suspend=${this.currentSuspendType}`;
        } else {
          hasFirstFiler = true;
          url = `${url}?is_suspend=${this.currentSuspendType}`;
        }
      }

      if (this.currentName) {
        if (hasFirstFiler) {
          url = `${url}&name=${this.currentName}`;
        } else {
          hasFirstFiler = true;
          url = `${url}?name=${this.currentName}`;
        }
      }

      if (page) {
        if (hasFirstFiler) {
          url = `${url}&page=${page}`;
        } else {
          hasFirstFiler = true;
          url = `${url}?page=${page}`;
        }
      }

      axios.get(url)
      .then((response) => {
        this.isSubmiting = false;
        this.total_team = response.data.total;
        this.makePagination(response.data);
        this.teams = response.data.data;
        this.isLoading = false;
        this.isError = false;
      })
      .catch(() => {
        this.isSubmiting = false;
        this.isLoading = false;
        this.isError = true;
      });
    },
    makePagination: function(data) {
      this.pagination.total = data.total;
      this.pagination.per_page = data.per_page;
      this.pagination.current_page = data.current_page;
      this.pagination.last_page = data.last_page;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.next_page_url = data.next_page_url;
      this.pagination.prev_page_url = data.prev_page_url;
      this.pagination.total_page = Math.ceil(data.total / data.per_page);
    },
    changePage: function(page) {
      this.fetchTeams(page);
    },
    filterItems: function () {
      this.fetchTeams();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TeamBrowser.vue?4815ecf0